
import { createPopper } from '@popperjs/core';
import tippy from 'tippy.js';

export default {

  init() {
    document.addEventListener('alpine:init', () => {
      this.tooltip();
      this.dropdown();
    });
  },

  // Directive: x-tooltip
  tooltip() {

    Alpine.directive('tooltip', (el, { value, modifiers, expression }, { evaluate }) => {
      let theme = el.dataset.theme ? el.dataset.theme : 'light';
      let message = value === 'message' ? evaluate(expression) : expression;
      tippy(el, { content: message, theme: theme, placement: 'bottom' });
    });
  },

  // Data: dropdown
  dropdown() {
    Alpine.data('dropdown', (el) => ({
      open: false,
      toggle() {
          if (this.open) {
              return this.close();
          }

          this.$refs.button.focus();

          this.open = true;
      },
      close(focusAfter) {
          if (! this.open) return;

          this.open = false;

          focusAfter && focusAfter.focus();
      },
      uncheckAll(target) {
        let inputs = target.querySelectorAll("input[type=checkbox]");

        inputs.forEach((input) => { input.checked = false });
      }
    }));
  },

}
